import { render, staticRenderFns } from "./004welcomYue.vue?vue&type=template&id=a05bbe7a&scoped=true&"
import script from "./004welcomYue.vue?vue&type=script&lang=js&"
export * from "./004welcomYue.vue?vue&type=script&lang=js&"
import style0 from "./004welcomYue.vue?vue&type=style&index=0&id=a05bbe7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05bbe7a",
  null
  
)

export default component.exports